<template>
    <div class="bg-white rounded shadow-sm mb-3">
        <div class="d-flex flex-row flex-wrap align-items-center justify-content-between mb-3" style="padding: 20px">
            <h3 class="h5 font-weight-semibold">QR Distribution Summary</h3>
            <div class="d-flex flex-row align-items-center">
                <div class="d-flex flex-row align-items-center flex-wrap">
                    <div style="width: 200px; margin: 5px 10px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="options.year"
                            class="qtrust-select"
                            placeholder="Semua Tahun"
                        ></MultiSelect>
                    </div>
                    <div style="width: 200px; margin: 5px 10px;">
                        <MultiSelect
                            v-model="filter.month"
                            :options="options.month.map(type => type.value)"
                            :custom-label="opt => options.month.find(x => x.value == opt).title"
                            class="qtrust-select"
                            placeholder="Semua Bulan"
                        ></MultiSelect>
                    </div>
                    <button
                        type="button"
                        class="btn"
                        style="background-color: white; padding: 4.5px 20px; border-radius: 4px; margin: 5px 10px; display: flex; align-items: center; font-size: 14px; cursor: pointer; font-weight: 500; border: 1px solid #e8e8e8;"
                        @click="exportToCSV" >Download CSV <i class="fas fa-file-download" style="margin-left: 8px;"></i></button>
                </div>
            </div>
        </div>

        <div class="w-100 overflow-auto">
            <table class="table w-100 qtrust-table">
                <thead>
                    <tr>
                        <th style="width: 25%;">Kode Dealer</th>
                        <th style="width: 25%;">Kode AHM</th>
                        <th style="width: 25%;">Tanggal</th>
                        <th style="width: 25%;">Jumlah Mapping</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="data" v-for="dat in data">
                        <td>{{ dat.loc_code }}</td>
                        <td>{{ dat.ahm_id }}</td>
                        <td>{{ moment(dat.scan_date).format('DD MMM YYYY') }}</td>
                        <td>{{ dat.count }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end align-items-center py-2 px-3" v-if="data">
            <p class="text-muted mb-0">Showing {{ (config.page-1)*config.limit+1 }}-{{ (config.page-1)*config.limit+data.length }} of {{ config.total }} items</p>
            <div class="d-flex align-items-center text-muted ml-3">
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(1)"><i class="fa fa-angle-double-left"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(config.page - 1)"><i class="fa fa-angle-left"></i></button>
                <p class="px-2 text-dark mb-0">{{ config.page }}</p>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.page + 1)"><i class="fa fa-angle-right"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.lastPage)"><i class="fa fa-angle-double-right"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import * as XLSX from 'xlsx';

    export default {

        data () {
            return {
                moment: moment,
                options : {
                    year :  [...new Set(Array.from({length:5}, (_,i)=>Math.max(parseInt(moment().format('YYYY'))-i, 2024)))],
                    month: Array.from({length: 12}, (_, i) => ({title: moment().month(i).format('MMMM'), value: i + 1})),
                },
                filter : {
                    year: moment().format('YYYY'),
                    month: null,
                },
                data : null,
                config : {
                    page: 1,
                    limit: 5,
                    lastPage: 0,
                    total: 0,
                },
            }
        },
        mounted () {
            this.fetchData();
        },
        watch : {
            'filter' : {
                deep: true,
                handler () {
                    this.config.page = 1;
                    this.fetchData();
                }
            },
            'config.page' : {
                deep: true,
                handler: 'fetchData'
            },
        },
        methods : {
            goToPage(page) {
                if (page >= 1 && page <= this.config.lastPage) this.config.page = page;
            },
            fetchData () {
                let filter = JSON.parse(JSON.stringify(this.filter));
                this.$http.get(`/api/qrs/mapping-pkb-daily`, {params: {...filter, ...{page: this.config.page, limit: this.config.limit}}})
                .then(async res => {
                    let data = res.data.data;
                    this.data = data;

                    this.config.lastPage = res.data.meta.lastPage;
                    this.config.total = res.data.meta.total;
                })
                .catch((err)=>console.log(err));
            },
            async exportToCSV() {
                // Fetch all data for export
                let filter = JSON.parse(JSON.stringify(this.filter));
                filter.all = 1;
                
                try {
                    const res = await this.$http.get(`/api/qrs/mapping-pkb-daily`, {params: {...filter}});
                    const allData = res.data.data;

                    const customHeaders = {
                        'loc_code': 'Kode Dealer',
                        'ahm_id': 'Kode AHM',
                        'scan_date': 'Tanggal',
                        'count': 'Jumlah Mapping',
                    };
                    
                    const modifiedData = (allData || []).map(item => {
                        const newItem = {};
                        for (const [oldKey, newKey] of Object.entries(customHeaders)) {
                            if (item.hasOwnProperty(oldKey)) {
                                if (oldKey === 'scan_date') {
                                    newItem[newKey] = this.moment(item[oldKey]).format('DD MMM YYYY');
                                } else {
                                    newItem[newKey] = item[oldKey];
                                }
                            }
                        }
                        return newItem;
                    });
                    
                    const worksheet = XLSX.utils.json_to_sheet(modifiedData);

                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

                    const timestamp = this.filter.year.toString() + (this.filter.month ? ('-' + String(this.filter.month).padStart(2, '0')) : '');
                    const filename = `distribution_summary_${timestamp}.csv`;

                    XLSX.writeFile(workbook, filename, { bookType: 'csv' });
                } catch (err) {
                    console.log('Export error:', err);
                }
            },
        },
    }
</script>

<style scoped>
    .qtrust-table > thead > tr > th {
        text-align: left;
        border-top: 2px solid #F3F3F3;
        border-bottom: 2px solid #F3F3F3;
        padding: 8px 16px;
    }

    .qtrust-table > tbody > tr > td {
        text-align: left;
        padding: 8px 16px;
        border-bottom: 1px solid #F3F3F3;
    }
</style>